















































































































































































import Vue from "vue";
import moment from "moment";

// Vue components
import TableFiltersRow from "@/components/TableHeaderFilters/TableFiltersRow.vue";
import DeviceModelChip from "@/views/App/Components/chips/DeviceModelChip.vue";
import BranchFilter from "@/components/TableHeaderFilters/BranchFilter.vue";
import TagsFilter from "@/components/TableHeaderFilters/TagsFilter.vue";
import DateRangeFilter from "@/components/TableHeaderFilters/DateRangeFilter.vue";
import MachineModelFilter from "@/components/TableHeaderFilters/MachineModelFilter.vue";
import NewSoftwareVersionsFilter from "@/components/TableHeaderFilters/NewSoftwareVersionsFilter.vue";
import ColumnVisibilityFilter from "@/components/DataTableColumnVisibilityFilter/ColumnVisibilityFilter.vue";
import RestoreBackupsDialog from "@/views/App/SecurityAndConfiguration/CaosConfiguration/RestoreBackupsDialog.vue";
import ConfigurationHistoryDialog from "@/views/App/SecurityAndConfiguration/CaosConfiguration/ConfigurationHistoryDialog.vue";

// Vuex
import { RootState } from "@/store";
import { mapState } from "vuex";

// Utility
import { dataTableItemsPerPage } from "@/utility/Constants";

// Model
import { InstallationUpdate } from "@/model/data/updates/InstallationUpdate";
import { UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";
import { UpdateVersionInfo } from "@/model/data/updates/UpdateVersionInfo";
import { SoftwareFilter } from "@/model/data/updates/SoftwareFilter";
import CreateTemplateDialog from "./CreateTemplateDialog.vue";
import {
    GetConfigurationVersionAndSectionsCommand,
    GetConfigurationVersionAndSectionsReqData,
} from "@/model/communication/caosConfiguration/GetConfigurationVersionAndSectionsCommand";
import { GetConfigurationVersionAndSectionsResData } from "@/model/communication/caosConfiguration/GetConfigurationVersionAndSectionsResData";
import { GetInstallationBackupsCommand } from "@/model/communication/caosConfiguration/GetInstallationBackupsCommand";
import { GetInstallationBackupsResData } from "@/model/communication/caosConfiguration/GetInstallationBackupsResData";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { CaosConfigurationTemplateContentsEnum } from "@/model/data/enums/CaosConfigurationTemplateContentsEnum";
import EditScheduleDialog from "../../ServiceAndUpdates/ScheduleConfiguration/EditScheduleDialog.vue";
import { ScheduleTypeEnum } from "@/model/data/scheduleSettings/ScheduleTypeEnum";

export default Vue.extend({
    components: {
        TableFiltersRow,
        DeviceModelChip,
        ColumnVisibilityFilter,
        CreateTemplateDialog,
        EditScheduleDialog,
        RestoreBackupsDialog,
        ConfigurationHistoryDialog,
    },
    props: {
        loading: { required: true, type: Boolean },
        paginatedTotalItems: Number,
        installations: { required: true, type: Array },
        reqData: Object,
    },
    data() {
        return {
            moment,
            ScheduleTypeEnum,
            loadingGetConfigVersion: false,
            prevIcon: "fas fa-chevron-left",
            nextIcon: "fas fa-chevron-right",
            NewSoftwareVersionsFilter,
            dataTableItemsPerPage,
            options: {},
            ignoreOptionsChanges: false,
            UpdateTypeEnum,
            types: { UpdateTypeEnum },
            selectedDevices: [],
            availableHeaders: [
                { enabled: true, text: this.$t("common.name"), value: "name", align: "center" },
                { enabled: false, text: this.$t("common.branch"), value: "branch.name", sortable: true, align: "center" },
                { enabled: false, text: this.$t("common.tags"), value: "tags", sortable: false, align: "center" },
                { enabled: true, text: this.$t("caosConfig.lastBackupDate"), value: "lastBackup", sortable: false, align: "center" },
                { enabled: false, text: this.$t("common.last_update"), value: "lastMessage", align: "center" },
                { enabled: false, text: this.$t("common.agent_ip"), value: "agentInfo.ip", align: "center" },
                { enabled: false, text: this.$t("device_status.agent_remote_ip"), value: "agentInfo.remoteIp", sortable: false, align: "center" },
                { enabled: false, text: this.$t("common.last_agent_message"), value: "agentInfo.lastMessage", sortable: true, align: "center" },
                { enabled: true, text: this.$t("enum.update_type.agent"), value: "agent", sortable: false, align: "center" },
                { enabled: true, text: this.$t("caosConfig.caosConfigurationVersion"), value: "caosConfigurationVersion", sortable: false, align: "center" },
                { enabled: true, text: this.$t("common.device/s"), value: "machines", sortable: false, align: "center" },
            ],
            filters: [
                {
                    headerValue: "branch.name",
                    filterKey: "branchNames",
                    component: BranchFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "tags",
                    filterKey: "tagValues",
                    component: TagsFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "lastMessage",
                    filterKey: "installationLastMessageDateRange",
                    component: DateRangeFilter,
                    currentSelections: [],
                    description: this.$t("common.dateRangeFilter", { property: this.$t("common.last_installation_message") }),
                },
                {
                    headerValue: "agentInfo.lastMessage",
                    filterKey: "agentLastMessageDateRange",
                    component: DateRangeFilter,
                    currentSelections: [],
                    description: this.$t("common.dateRangeFilter", { property: this.$t("common.last_agent_message") }),
                },
                {
                    headerValue: "caosConfigurationVersion",
                    filterKey: UpdateTypeEnum.Caos,
                    component: NewSoftwareVersionsFilter,
                    currentSelections: [],
                    customAttrs: { filterUpdateType: UpdateTypeEnum.Caos, versionType: "caosConfiguration" },
                },
                {
                    headerValue: "machines",
                    filterKey: "machineModels",
                    component: MachineModelFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "agent",
                    filterKey: UpdateTypeEnum.Agent,
                    component: NewSoftwareVersionsFilter,
                    currentSelections: [],
                    customAttrs: { filterUpdateType: UpdateTypeEnum.Agent },
                },
            ],
            showCreateTemplateDialog: false,
            newTemplate: null,
            error: false,
            errorMessage: "",
            availableConfigSections: [],
            newTemplateBaseConfiguration: null,
            newTemplateSourceInstallationName: "",
            newTemplateCaosVersion: "",
            showEditScheduleDialog: false,
            loadingGetInstallationBackups: false,
            showRestoreBackupDialog: false,
            caosConfigurationBackups: [],
            restoreInstallation: "",
            showHistoryDialog: false,
            historyInstallation: "",
        };
    },
    computed: {
        ...mapState({
            availableSoftwareFilter: (state: RootState): SoftwareFilter[] => state.application.availableSoftwareVersions,
        }),
    },
    watch: {
        options: {
            handler(newOptions, oldOptions) {
                if (oldOptions != null) {
                    if (newOptions.page < oldOptions.page) this.prevIcon = "fas fa-circle-notch fa-spin";
                    if (newOptions.page > oldOptions.page) this.nextIcon = "fas fa-circle-notch fa-spin";
                }
                if (!this.ignoreOptionsChanges) this.$emit("options-changed", newOptions);
                else this.ignoreOptionsChanges = false;
            },
            deep: true,
        },
        loading(newVal) {
            if (!newVal) {
                this.prevIcon = "fas fa-chevron-left";
                this.nextIcon = "fas fa-chevron-right";
            }
        },
    },
    methods: {
        backToTheFirst() {
            if (this.options.page != 1) {
                this.ignoreOptionsChanges = true;
                this.options.page = 1;
                console.debug("backToTheFirst, this.options: ", this.options);
            }
        },

        getInstallationSwsByTypeAndName(installation: InstallationUpdate, updateType: UpdateTypeEnum, swName: string): UpdateVersionInfo[] {
            let res = [];
            if (installation.installedSoftwaresVersions)
                installation.installedSoftwaresVersions.forEach((sw) => {
                    if (swName == null && sw.updateType == updateType) res.push(sw);
                    if (swName != null && sw.updateType == updateType && sw.name == swName) res.push(sw);
                });
            return res;
        },

        getInstallationSwsByType(installation: InstallationUpdate, updateType: UpdateTypeEnum): UpdateVersionInfo[] {
            return this.getInstallationSwsByTypeAndName(installation, updateType, null);
        },

        async sendRequestGetConfigurationVersion() {
            this.loadingGetConfigVersion = true;
            this.showCreateTemplateDialog = true;
            this.error = false;
            this.errorMessage = "";
            let reqData = new GetConfigurationVersionAndSectionsReqData(this.selectedDevices[0].name);
            let response: GetConfigurationVersionAndSectionsResData = await new GetConfigurationVersionAndSectionsCommand(reqData).execute();
            if (response.responseStatus == ApiResponseStatusEnum.Success && response.responseString != "GenericError") {
                this.newTemplateSourceInstallationName = this.selectedDevices[0].name;
                this.newTemplateCaosVersion = response.caosConfiguration.caosVersion;
                this.newTemplateBaseConfiguration = response.caosConfiguration;
                Object.keys(response.caosConfiguration).forEach((key) => {
                    if (key != "caosVersion" && !response.caosConfiguration[key]["binding"]) {
                        this.availableConfigSections.push({
                            name: key,
                            namei18n: this.$t(`enum.caosConfigurationTemplateContents.${key}`),
                            contentValue: CaosConfigurationTemplateContentsEnum[key],
                        });
                    }
                });
            } else {
                this.error = true;
                if (response.message == "DeviceLocked") this.errorMessage = this.$t("caosTemplate.deviceBusyError");
                else if (response.message == "ConnectionLimitReached") this.errorMessage = this.$t("caosTemplate.agentTimeout");
                else if (response.message == "AgentOffline") this.errorMessage = this.$t("caosTemplate.agentOfflineForInstallation", { task: "create a template" });
                else this.errorMessage = this.$t("caosTemplate.noConfigError");
            }
            this.loadingGetConfigVersion = false;
        },

        async sendRequestGetInstallationBackups() {
            this.loadingGetInstallationBackups = true;
            this.showRestoreBackupDialog = true;
            let response: GetInstallationBackupsResData = await new GetInstallationBackupsCommand(this.selectedDevices[0].name).execute();
            if (response.responseStatus == ApiResponseStatusEnum.Success && response.responseString != "GenericError") {
                this.caosConfigurationBackups = response.caosConfigurationBackups;
                this.restoreInstallation = this.selectedDevices[0].name;
            }
            this.loadingGetInstallationBackups = false;
        },

        showConfigurationHistoryDialog() {
            if (this.selectedDevices && this.selectedDevices.length == 1 && this.selectedDevices[0].name) {
                this.historyInstallation = this.selectedDevices[0].name;
                this.showHistoryDialog = true;
            }
        },
    },
});
